import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useFormikContext } from 'formik';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { CircularProgress, Grid, useMediaQuery } from '@material-ui/core';
import { StoreContext } from 'utils/contextStore';
import { initialValues } from 'components/ModalPAC/index';
import { useHistory } from 'react-router-dom';
import PAGES from 'routes/pages';
import ActiveStep from './activeStep';
import StepperComponent from '../DeclareFolderProcess/stepper';
import { getOrganismesPAC, setPacResponse } from '../../../store/pac/actions';
import { CircularProgressWrapper } from './styles';
import SuccessFailed, {
  SuccessFailedType,
} from '../DeclareFolderProcess/successFailed';
import {
  closeModalPAC,
  setAMCDetailsPageBreadcrumbsPath,
} from '../../../store/global/actions';

export const PACProcess = () => {
  const { resetForm } = useFormikContext<any>();
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const { PACProcessStepsState } = React.useContext(StoreContext);
  const getStep = PACProcessStepsState?.PACProcessStep;
  const setStep = PACProcessStepsState?.setPACProcessStep;
  const isNotMobile = useMediaQuery('(min-width:960px)');
  const isLoadingPACOrganismes = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'isLoadingPACOrganismes']),
  );
  const isLoadingCategories = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'isLoadingCategories']),
  );
  const responsePAC = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'responsePAC']),
  );
  const [dataSuccessFailed, setDataSuccessFailed] = useState<SuccessFailedType>(
    {
      icon: 'successIcon',
      title: '',
      secondTitle: '',
      actionOne: /* istanbul ignore next */ () => {},
      actionTwo: /* istanbul ignore next */ () => {},
      actionOneTitle: '',
      actionTwoTitle: '',
    },
  );
  const isLoading =
    (isLoadingPACOrganismes && getStep === 0) ||
    (isLoadingCategories && getStep === 1);

  const steps = [
    intl.formatMessage({
      id: 'Home_text_Health_declarer_une_personne_identite_step',
    }),
    intl.formatMessage({ id: 'Home_text_Health_declarer_une_personne_step1' }),
    intl.formatMessage({ id: 'Home_text_Health_declarer_une_personne_step2' }),
    intl.formatMessage({ id: 'Home_text_Health_declarer_une_personne_step3' }),
    intl.formatMessage({ id: 'Home_text_Health_declarer_une_personne_step4' }),
  ];

  /* istanbul ignore file */
  const failCommunActions = useCallback(() => {
    resetForm({ values: initialValues });
    setStep(0);
    dispatch(setPacResponse(null));
  }, [dispatch, resetForm, setStep]);

  /* istanbul ignore file */
  const failActionOne = useCallback(() => {
    dispatch(getOrganismesPAC());
    failCommunActions();
  }, [dispatch, failCommunActions]);

  /* istanbul ignore file */
  const actionTwo = useCallback(() => {
    failCommunActions();
    dispatch(closeModalPAC());
  }, [dispatch, failCommunActions]);

  useEffect(() => {
    dispatch(getOrganismesPAC());
  }, [dispatch]);

  /* istanbul ignore next */
  useEffect(() => {
    if (responsePAC?.ReferenceDemande) {
      setDataSuccessFailed({
        icon: 'successIcon',
        title: intl.formatMessage({ id: 'dmo.success.title' }),
        secondTitle: `${intl.formatMessage({
          id: 'pac.declaration.success.part1',
        })} ${responsePAC.ReferenceDemande} ${intl.formatMessage({
          id: 'pac.declaration.success.part2',
        })}`,
        actionOne: () => {
          actionTwo();
          dispatch(
            setAMCDetailsPageBreadcrumbsPath([
              { name: 'amc', route: PAGES.AMC_DASHBOARD },
              { name: 'suiviPAC' },
            ]),
          );
          history.push(PAGES.AMC_DETAILS);
        },
        actionTwo: () => actionTwo(),
        actionOneTitle: intl.formatMessage({
          id: 'pac.suivi.declaration.button.title',
        }),
        actionTwoTitle: intl.formatMessage({ id: 'dmo.success.back.home' }),
      });
    } else if (responsePAC?.Message) {
      setDataSuccessFailed({
        icon: 'errorIcon',
        title: intl.formatMessage({ id: 'pac.error' }),
        secondTitle: responsePAC.Message,
        actionOne: () => failActionOne(),
        actionTwo: () => actionTwo(),
        actionOneTitle: intl.formatMessage({
          id: 'auth_by_contract_failed.next_label',
        }),
        actionTwoTitle: intl.formatMessage({ id: 'dmo.success.back.home' }),
      });
    }
  }, [actionTwo, failActionOne, intl, responsePAC]);

  return (
    <>
      {responsePAC ? (
        <SuccessFailed
          icon={dataSuccessFailed.icon}
          title={dataSuccessFailed.title}
          secondTitle={dataSuccessFailed.secondTitle}
          actionOne={dataSuccessFailed.actionOne}
          actionTwo={dataSuccessFailed.actionTwo}
          actionOneTitle={dataSuccessFailed.actionOneTitle}
          actionTwoTitle={dataSuccessFailed.actionTwoTitle}
        />
      ) : (
        <Grid container>
          {isNotMobile && (
            <Grid md={4} item>
              <StepperComponent activeStep={getStep} steps={steps} />
            </Grid>
          )}
          <Grid
            item
            md={8}
            xs={12}
            style={{
              padding: '24px',
              alignSelf: isLoading ? 'center' : 'flex-start',
            }}
          >
            {isLoading ? (
              <CircularProgressWrapper>
                <CircularProgress data-testid="loader" size={20} />
              </CircularProgressWrapper>
            ) : (
              <ActiveStep activeStep={getStep} />
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
};
